<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else class="container-box min-vh-100">
      <HeaderMenuPrivilege
        :title="'PRIVILEGE CODE'"
        :link="'/privilegecode/details/0'"
        :filter="filter"
        @handleSearch="handleSearch"
        @sidebarFilter="sidebarFilter"
        :placeholder="'Search Name, Detail, Privilege Code'"
      />
      <div>
        <SideBarFilter
          ref="sidebarFilter"
          :filter="filter"
          :placeholder="'Search Name, Detail, Privilege Code'"
          @searchAll="handleSearch"
          @clearFilter="clearFilter"
        >
          <template v-slot:checkbox-option>
            <div class="mt-3">
              <div>
                <div class="font-weight-bold mb-2">Valid From</div>
                <div :class="['input-container']">
                  <datetime
                    :input-style="styleDatetime"
                    format="dd/MM/yyyy"
                    value-zone="local"
                    v-model="filter.start_date"
                    ref="startDate"
                    placeholder="Please select date"
                  >
                  </datetime>
                  <div
                    class="icon-container text-right"
                    @click="$refs.startDate.isOpen = true"
                  >
                    <font-awesome-icon
                      icon="calendar-alt"
                      class="pointer color-primary"
                      color="#B41BB4"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-3 mb-3">
                <div class="font-weight-bold mb-2">Valid To</div>
                <div :class="['input-container']">
                  <datetime
                    :input-style="styleDatetime"
                    format="dd/MM/yyyy"
                    value-zone="local"
                    v-model="filter.end_date"
                    placeholder="Please select date"
                    ref="endDate"
                  >
                  </datetime>
                  <div
                    class="icon-container text-right"
                    @click="$refs.endDate.isOpen = true"
                  >
                    <font-awesome-icon
                      icon="calendar-alt"
                      class="pointer color-primary"
                      color="#B41BB4"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </SideBarFilter>
      </div>
      <div class="bg-white border-red px-1 px-sm-3 pb-3 mt-3">
        <b-row class="mt-3">
          <b-col>
            <b-table
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
            >
              <template v-slot:cell(image_url)="data">
                <div
                  class="position-relative image"
                  v-bind:style="{
                    'background-image': 'url(' + data.item.image_url + ')',
                  }"
                ></div>
              </template>
              <template v-slot:cell(validFrom)="data">
                <div>
                  {{ $moment(data.item.validFrom).format("DD/MM/YYYY") }}
                </div>
                <div class="time">
                  ({{ $moment(data.item.validFrom).format("HH:mm:ss") }})
                </div>
              </template>
              <template v-slot:cell(validTo)="data">
                <div class="justify-content-center">
                  <div>
                    {{ $moment(data.item.validTo).format("DD/MM/YYYY") }}
                  </div>
                  <div class="time">
                    ({{ $moment(data.item.validTo).format("HH:mm:ss") }})
                  </div>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <div v-if="data.item.status == 1" class="text-success">
                  Active
                </div>
                <div v-else class="text-danger">Inactive</div>
              </template>
              <template v-slot:cell(name)="data">
                <div class="justify-content-center text-left">
                  <router-link :to="'/privilegecode/details/' + data.item.id">
                    <u> {{ data.item.name }}</u>
                  </router-link>
                  <div class="line-clamp2">
                    {{ data.item.short_description }}
                  </div>
                  <div
                    class="badge badge-secondary"
                    v-for="(coupon, index) in data.item.tag_coupon"
                    :key="index"
                  >
                    {{ coupon.name }} ({{ coupon.discount }}
                    {{ coupon.max_quantity }} สิทธิ์,
                    {{ $moment(coupon.validFrom).format("DD/MM/YYYY") }} -
                    {{ $moment(coupon.validTo).format("DD/MM/YYYY") }})
                  </div>
                </div>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SideBarFilter from "@/components/SideBarFilter";
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderMenuPrivilege from "@/components/privilegeDetail/HeaderMenuPrivilege";
import Pagination from "@/components/Pagination";
export default {
  components: {
    OtherLoading,
    SideBarFilter,
    HeaderMenuPrivilege,
    Pagination,
  },
  name: "PrivilegeCodeIndex",
  data() {
    return {
      fields: [
        {
          key: "image_url",
          label: "Photo",
          class: "w-200",
        },
        {
          key: "name",
          label: "Name / Detail",
        },
        {
          key: "prefix",
          label: "Privilege Code",
        },
        {
          key: "validFrom",
          label: "Valid From",
        },
        {
          key: "validTo",
          label: "Valid To",
        },
        {
          key: "sort_order",
          label: "No.",
        },
        {
          key: "status",
          label: "Status",
        },
      ],
      items: [],
      isBusy: false,
      isLoadingData: false,
      checkAll: false,
      selectAllCb: false,
      rows: 0,
      showing: 1,
      showingTo: 10,
      checkboxActive: false,
      checkboxInactive: false,
      filter: {
        search: "",
        page: 1,
        take: 10,
        status: [],
        start_date: "",
        end_date: "",
      },
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      selected: 0,
      isLoading: true,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
    };
  },
  created: async function () {
    await this.getList();
  },
  methods: {
    getList: async function () {
      let payload = { ...this.filter };
      payload.status =
        this.filter.status.length == 1 ? this.filter.status[0] : null;
      payload.start_date =
        payload.start_date == "" ? "0001-01-01" : payload.start_date;
      payload.end_date =
        payload.end_date == "" ? "0001-01-01" : payload.end_date;
      this.isLoadingData = true;
      await this.$store.dispatch("ActionGetPrivilegeCode", payload);
      var data = await this.$store.state.modulePrivilegeCode
        .stateGetPrivilegeCode;
      this.isLoading = false;
      if (data.result == 1) {
        this.items = data.detail.detail;
        this.rows = data.detail.total_count;
        this.isLoadingData = false;
      }
    },
    handleSearch(value) {
      this.filter = value;
      this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
      this.getList();
    },
    clearFilter() {
      this.filter = {
        search: "",
        page: 1,
        take: 10,
        status: [],
        start_date: "",
        end_date: "",
      };
    },
    sidebarFilter() {
      this.$refs.sidebarFilter.show(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.image {
  width: 100%;
  padding-top: 42.9%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
::v-deep thead {
  background-color: var(--secondary-color);
  color: var(--font-color);
}
.time {
  color: #afafaf;
}
.line-clamp2 {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
::v-deep .nameOfTheClass {
  max-width: 300px !important;
}

.btn-close {
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
}
.image {
  width: 50%;
  height: 50%;
  padding-top: 42.9%;
  margin-left: 25%;
  background-position: center !important;
  background-size: cover;
  background-repeat: no-repeat;
}
::v-deep .width-td-img {
  width: 200px !important;
}
.badge {
  font-size: 85%;
  background-color: var(--secondary-color);
  color: var(--primary-color);
  font-weight: 100;
}
</style>
